import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../core/services/api.service';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { SharedService } from '../../../../shared/services/shared.service';
import { DatePipe } from '@angular/common';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { AccountManagementSharedService } from '../services/account-management-shared.service';
import { ConfirmationModalComponent } from '../../../../shared/components/confirmation-modal/confirmation-modal.component';
import { mapServicesFromFlags } from '../../../../shared/constants/services.enum';
import { DcMethodValues } from '../../../../shared/constants/dc-method.constants';

@Component({
  selector: 'app-user-detail',
  imports: [TranslateModule, ButtonComponent, DatePipe, SkeletonLoaderComponent, ConfirmationModalComponent],
  templateUrl: './user-detail.component.html',
  styleUrl: './user-detail.component.scss'
})
export class UserDetailComponent implements OnInit {
  req: any = {
    englishName: '',
    arabicName: '',
    nationality: '',
    userType: '',
    access: '',
    legalStatus: '',
    issueDate: '',
    phone: '',
    email: ''
  };
  csn: string = '';
  userId: string = '';
  loader: boolean = false;
  unlinkUserLoader: boolean = false;
  showUnlinkConfirmation: boolean = false;
  lang: string = 'en';
  loginUser: any = null;
  isPrimaryUser: boolean = false;
  accessableServices: any = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private sharedService: SharedService,
    private accountManagementSharedService: AccountManagementSharedService
  ) { }

  ngOnInit(): void {
    this.lang = this.sharedService.getCurrentLang();
    this.loginUser = this.sharedService.getUserProfile();
    this.route.params.subscribe(params => {
      this.csn = params['csn'] || '';
      this.userId = params['userId'] || '';
      if (this.csn && this.userId) {
        this.getUserDetail();
      } else {
        this.router.navigate([RoutesPath.ACCOUNT_MANAGEMENT]);
      }
    });
    this.isPrimaryUser = this.sharedService.checkPrimaryUser(this.csn);
  }


  isSameUserAsLogin() {
    let userLoginName = this.sharedService.getUserProfile()['Login Name'];
    if (userLoginName == this.userId) {
      return true;
    }
    return false;
  }

  private getUserDetail(): void {
    if (!this.csn && !this.userId) {
      return;
    }
    this.loader = true;
    this.accountManagementSharedService
      .getUserAccessDetails(this.csn, this.userId, DcMethodValues.USER_DETAIL)
      .subscribe({
        next: (response: any) => {
          this.loader = false;
          if (response['Error Code'] == "" && response['Error Message'] == "") {
            const detail = response?.SiebelMessage?.["User Details"];

            const userAccess = detail?.['User Access Details'];

            const accessDetail =
              Array.isArray(userAccess) && userAccess.length > 0
                ? userAccess[0]
                : userAccess ?? null;
            this.req =
            {
              englishName: detail['DC Name English'],
              arabicName: detail['DC Name Arabic'],
              nationality: detail['DC Nationality'],
              userType: accessDetail ? accessDetail['DC User Type'] : '-',
              access: accessDetail ? accessDetail['DC User Type'] : '-',
              legalStatus: detail['DC Legal Status'] ? detail['DC Legal Status'] : (accessDetail['DC Legal Status'] ?? '-'),
              issueDate: detail['DC Customer Since'] ? detail['DC Customer Since'] : (accessDetail['DC Customer Since'] ?? '-'),
              phone: detail['Work Phone #'] ? detail['Work Phone #'] : detail['Cellular Phone'],
              email: detail['Email Address']
            }
            this.accessableServices = mapServicesFromFlags(accessDetail);

          } else {
            this.sharedService.toastMessage('Error', 'TECHNICAL_ERROR', 'error');
          }
        },
        error: () => {
          this.loader = false;
        }
      });
  }

  update() {
    this.router.navigate([RoutesPath.SERVICE + "/" + RoutesPath.UPDATE_USER, this.csn, this.userId]);
  }

  removeUser() {
    this.showUnlinkConfirmation = true;
  }

  closeUnlinkConfirmation() {
    this.showUnlinkConfirmation = false;
  }

  confirmUnLinkUser() {
    if (!this.csn || !this.userId) {
      return;
    }
    const loginUserName = this.loginUser?.['Login Name'] || '';
    this.unlinkUserLoader = true;
    this.accountManagementSharedService
      .unlinkUser(this.csn, loginUserName, this.userId, this.lang)
      .subscribe({
        next: (response: any) => {
          this.unlinkUserLoader = false;
          this.showUnlinkConfirmation = false;
          if (response["Error Code"] == null && response["Error Message"] == null) {
            this.sharedService.toastMessage('SUCCESS', 'SUCCESS', 'success');
            this.router.navigate([RoutesPath.MEMBERSHIP.DETAIL, this.csn]);
          } else {
            this.sharedService.toastMessage('Error', 'TECHNICAL_ERROR', 'error');
          }
        },
        error: () => {
          this.unlinkUserLoader = false;
          this.showUnlinkConfirmation = false;
        }
      });
  }
}
